import { BackgroundAuth, CardAuth, LoginAuth, TitleAuth } from './layoutAuthStyle'
import { logo } from '../../constants/images'
import { useEffect, useState } from 'react'
interface propsTypes {
    children: any
}
export default function LayoutAuth(props: propsTypes) {
    const { children } = props
    const [url, setUrl] = useState<string>('')

    useEffect(() => {
        const init = async () => {
          const response = await fetch("/resources/config.json");
          const results = await response.json();
          setUrl(results.REACT_APP_BASE_API);
        }
        init()
      }, [])
    return (
        <BackgroundAuth>
            <CardAuth>
                <LoginAuth src={`${url}/app-logo`} alt='logo-login' />
                <TitleAuth>ระบบจัดเก็บเอกสารอิเล็กทรอนิกส์ (e-Document)</TitleAuth>
                {children}
            </CardAuth>
        </BackgroundAuth>
    )
}
